import React from 'react';
import {
	Box,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
} from '@mui/material';
import { Link } from 'react-router-dom';

export default function GroupTableData(props) {
	const data = props.groupArray;
	const tableData = () => {
		return (
			<Box className='table_responsive'>
				<TableContainer className='tbl_mn br-24 br-btm-0 '>
				<Table className='table-design'>
					<TableHead>
						<TableRow className='tbl_rw'>
							<TableCell className='fz-18 fw-bold'>Group Name</TableCell>
							<TableCell className='fz-18 fw-bold'>Owner Name</TableCell>
							<TableCell className='fz-18 fw-bold'>Participant Count</TableCell>
							<TableCell className='fz-18 fw-bold'>Payment Amount</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>						
							{
								data?.length > 0 ? data?.map((item, i) => {
									return(
										<TableRow key={i}>
											<TableCell className='fz-16' scope='row'>
												{item?.group_name}
											</TableCell>
											<TableCell className='fz-16'>{item?.created_by?.first_name +" "+ item?.created_by?.last_name}</TableCell>
											<TableCell className='fz-16'>{item?.participants.length}</TableCell>
											<TableCell className='fz-16'>{item?.payment_amount}
											</TableCell>
										</TableRow>
									)
								}) : 
								<TableRow>
									<TableCell className='fz-16' scope='row'>
										"No Records Found"
									</TableCell>
								</TableRow>
							}
					</TableBody>
				</Table>
			</TableContainer>
			</Box>
		);
	};

	return (
		<Box height='100%' display='flex' className='box-wrapper br-24' flexDirection='column' justifyContent='start'>
			<div className='heading-btn_wrapper'>
				<h5 className='fz-20 fw-bold'>Recent Groups</h5>
				<Link to='/groups' className='learn-btn '>
					View More
				</Link>
			</div>
			{tableData()}
		</Box>
	);
}
